// Supplier Portal route-path constants — single importable source (#7618, Option A).
// TierDetail.tsx and tiersUtils.tsx keep their own local copies deliberately (locked decision).
export const SUPPLIER_PORTAL_PATH = '/supplier-portal'
/** antd submenu key for the Configurations group — a path PREFIX used for open/selection derivation, not a routable target. */
export const SUPPLIER_PORTAL_CONFIGURATIONS_KEY = '/supplier-portal/configurations'
export const CATALOG_PATH = '/supplier-portal/configurations/catalog'
export const CROSSES_PATH = '/supplier-portal/configurations/crosses'
export const TIERS_PATH = '/supplier-portal/configurations/tiers'
export const BATCH_RESULTS_PATH = '/supplier-portal/configurations/batch-results'
export const EMPTY_CATALOG_PATH = '/supplier-portal/configurations/empty-catalog'
/**
 * The opportunity-detail base URL (STORY 7339, spec §5.1) — the Summary landing, since Summary's slug is
 * the empty splat. Five consumers (the page itself plus the four entry points), so it lives here under the
 * single-importable-source rule rather than being re-derived at each call site. Stays dependency-free.
 */
export const opportunityDetailPath = (opportunityId: string): string =>
  `${SUPPLIER_PORTAL_PATH}/opportunities/${opportunityId}`
